// extracted by mini-css-extract-plugin
export default {"pageContainer":"styles_pageContainer__qSxBR","droppablePage":"styles_droppablePage__sk0IK","documentPage":"styles_documentPage__mNedQ"};